// Rounds to nearest mile
export default function milesToMeters(miles: number): number {
  return Math.round(miles * 1609.34)
}

export function milesToKilometers(miles: number): number {
  return Math.round(miles * 1.60934)
}
